import { memo } from 'react'
import { getPriceFormatter, formatNumberToPrice } from 'root/constants'

const Price = ({ currency, value }) => (value >= 0 ? formatNumberToPrice(value, getPriceFormatter(currency)) : '')

export default memo(Price)
